export const infinityScrollPageSize = 18

/*
TODO!!!
 Temporary values, remove these at a later stage.
 Preferably these category IDs 
 should have a takebackbanner boolean
 coming from product API
*/
export const TAKEBACK_BANNER_CATEGORY_IDS = new Set([
  /* CATEGORY_PAGE */
  '2037749', //Computer & Tablets
  '2037751', //Computer Accessories / Monitor & Computer Accessories
  '2029810', //Phones & GPS
])

export const HARDWARE_CATEGORY_ID = '2037738'

export const newProductsOnlyFacets = [
  { name: 'showonly', values: ['isnewproduct'] },
  { name: 'isnewproduct', values: ['true'] },
]
